import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CompanyInactivateObservable(implementationID: number, accountID: number, isLocation: boolean = false): Observable<string> {
  const requestBody: string = new URLSearchParams({
    implementationID: implementationID.toString(),
    accountId: accountID.toString(),
    isLocation: isLocation.toString()
  }).toString()

  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/InActivateClient?" + requestBody)
}
